import { register } from 'register-service-worker'

const announce = (code, message) => {
  if (typeof BroadcastChannel === 'undefined') return
  const channel = new BroadcastChannel('sw-messages')
  channel.postMessage({ type: 'appMessage', code, message })
  channel.close()
}
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    registrationOptions: { updateViaCache: 'none' },
    ready() { announce('READY') },
    registered() { announce('REGISTERED') },
    cached() { announce('CACHED') },
    updatefound() { announce('UPDATEFOUND') },
    updated(registration) {
      announce('UPDATED')
      document.dispatchEvent(new CustomEvent('swUpdated', { detail: registration }))
    },
    offline() { announce('OFFLINE') },
    error(error) {
      console.warn('Service worker registration failed:', error?.name || 'Error')
      announce('ERROR', 'Не удалось подготовить офлайн-ресурсы или обновление приложения.')
    },
  })
}